module.exports = __webpack_public_path__ + "img/JDB.80321829.png";